module.exports = __webpack_public_path__ + "static/media/logout.f1f14bce.svg";